import { Divider } from "@mui/material"
import { If } from "lib/@components/switch"
import { Frag } from "lib/@components/slot/frag"
import { DifferenceEntry } from "slot-definitions"

// A task has one note for the whole task, so its changed fields render as plain diffs with no per-field note.
export function AuthoringReviewComparisonTypePlainEntry({ component, last }) {
    const { type: Type, props } = component

    return (
        <Frag>
            <DifferenceEntry.Slot>
                <Type {...props} />
            </DifferenceEntry.Slot>
            <If value={!last}>
                <Divider sx={{ mx: -3 }} />
            </If>
        </Frag>
    )
}
